import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * The personal links sent before the start page became the only surface
 * (`/presentation/partner/:token`, `/pitch/partner/:token`): forwarded to
 * `/start/partner/:token` with the token and the query string intact, so a
 * link already in someone's inbox keeps working.
 */
const StartLinkRedirect: React.FC = () => {
  const { token = '' } = useParams<{ token: string }>();
  const { search } = useLocation();

  return <Navigate to={`/start/partner/${encodeURIComponent(token)}${search}`} replace />;
};

export default StartLinkRedirect;
